import { HomeWrapper } from "./styled"
import SliderImage from "components/SliderImage"
import TourList from "components/TourList"
import { homeActions } from "redux/slice/homeSlice"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import { homeSelector } from "redux/selector"
import Loading from "components/Loading"
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";
import NewsList from "components/NewsList"

const Home = () => {
    const dispatch = useDispatch()
    const homeState = useSelector(homeSelector)
    useEffect(() => {
        dispatch(homeActions.getHomeData())
    }, [dispatch])


    useEffect(() => {
        const chatbox = document.getElementById("fb-root");
        if (chatbox)
            chatbox.style.display = "block"

    }, [])

    return (
        <HomeWrapper>
            {
                homeState.loading &&
                <Loading />
            }
            <div className="home_slide_img">
                <SliderImage />
            </div>
            <div className="grid wide">

                <div className="home_container">
                    {
                        homeState?.homeData?.tourNewData?.length > 3 &&
                        <div className="home_product">
                            <TourList data={homeState.homeData.tourNewData} title="Tour mới nhất" />
                        </div>
                    }
                    {
                        homeState?.homeData?.tourHotData?.length > 3 &&
                        <div className="home_product">
                            <TourList data={homeState.homeData.tourHotData} title="Tour phổ biến" />
                        </div>
                    }
                    {
                        homeState?.homeData?.favoriteData?.length > 3 &&
                        <div className="home_product">
                            <TourList data={homeState.homeData.favoriteData} title="Tour được yêu thích nhiều nhất" />
                        </div>
                    }
                    {
                        homeState.homeData?.newNews.length > 3 &&
                        <div className="home_news">
                            <NewsList data={homeState.homeData.newNews} />
                        </div>
                    }
                    <div className="link_sticky">
                        <span className="clickable">
                            <FaFacebook className="text-link" style={{ fontSize: "30px" }} />
                        </span>
                        <span className="mt-20 clickable">
                            <FaInstagram className="text-red" style={{ fontSize: "30px" }} />
                        </span>
                        <span className="mt-20 clickable">
                            <FaYoutube className="text-red" style={{ fontSize: "30px" }} />
                        </span>
                    </div>
                </div>
            </div>
        </HomeWrapper>
    )
}

export default Home